import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, NgClass, TitleCasePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DetailListCardComponent } from './detail-list-card/detail-list-card.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-list-card',
  templateUrl: './list-card.component.html',
  styleUrls: ['./list-card.component.scss'],
  standalone: true,
  imports: [RouterLink, NgClass, DetailListCardComponent, TitleCasePipe, TranslateModule]
})
export class ListCardComponent {

  @Input() list: any = [];
  @Input() isHome = false;

  public urlTemporal = '../../assets/images/help.png';

  constructor(@Inject(PLATFORM_ID) private platformId: string,
  ) {
  }

  public onSeeMoreNavigation(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
    }
  }

  public goDetails(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
    }
  }

}
